var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pagination__container" }, [
    _c(
      "nav",
      {
        staticClass: "d-flex justify-content-lg-center",
        attrs: { "aria-label": "Page navigation example" },
      },
      [
        _vm.totalPages > 1
          ? _c(
              "ul",
              { staticClass: "pagination" },
              [
                _c(
                  "li",
                  {
                    staticClass: "page-item previous",
                    class: { disabled: _vm.isFirstPage },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "page-link",
                        attrs: { type: "button", disabled: _vm.isFirstPage },
                        on: { click: _vm.handleClickPreviousPage },
                      },
                      [_c("i", { staticClass: "icon-arrow-left" })]
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.pages, function (page) {
                  return _c(
                    "li",
                    {
                      staticClass: "page-item",
                      class: { active: _vm.isActive(page.content) },
                    },
                    [
                      page.breakView
                        ? _c("a", { staticClass: "page-link" }, [_vm._v("...")])
                        : _c(
                            "a",
                            {
                              staticClass: "page-link",
                              attrs: { disabled: page.disabled },
                              on: {
                                click: function ($event) {
                                  return _vm.handleClickPage(page.content)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(page.content) +
                                  "\n                "
                              ),
                            ]
                          ),
                    ]
                  )
                }),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "page-item next",
                    class: { disabled: _vm.isLastPage },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "page-link",
                        attrs: { type: "button", disabled: _vm.isLastPage },
                        on: { click: _vm.handleClickNextPage },
                      },
                      [_c("i", { staticClass: "icon-arrow-right" })]
                    ),
                  ]
                ),
              ],
              2
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }